<div class="container">
  <div class="content-message">
    <mat-icon color="accent">info</mat-icon>
    <ng-container *ngIf="user?.roles.isManagerNurse; else noLead">
      <p>This patient is close to reaching billable activity for the month.</p>
    </ng-container>
    <ng-template #noLead>
      <p>
        This patient is close to reaching billable activity for the month. Please create a task for the lead nurse to
        review and approve the patient's disenrollment from this program.
      </p>
    </ng-template>
  </div>
  <div class="info">
    <span
      >Program:
      <h3>{{ data.program | uppercase }}</h3></span
    >
    <span
      >Time:
      <h3>{{ roundTime(data.timeReport) }}</h3></span
    >
    <span *ngIf="data.program === 'rpm'"
      >Unique Measures:
      <h3>{{ data.uniqueMeasures }}</h3></span
    >
  </div>
  <div class="actions">
    <button mat-raised-button (click)="close()">Close</button>
    <button
      mat-raised-button
      color="accent"
      (click)="disenroll()"
      *ngIf="user?.roles.isManagerNurse; else noLeadButton"
    >
      Approve Disenrollment
    </button>
    <ng-template #noLeadButton>
      <button mat-raised-button color="accent" (click)="sendAlert()">Create Task</button>
    </ng-template>
  </div>
</div>
